import { BoardSectionItemHighlight } from '#components/Board/Section/Items/BoardSectionItemHighlight';
import { ImageModule } from '#components/Image/ImageModule';
import type { LinkTeaser } from '#domains/resolver/board-section-data';
import { TrackEventDataType } from '#types/tracking';
import { Tracktor } from 'react-tracktor';

type Props = {
	teaser: LinkTeaser;
	sizes: string;
};

export function BoardSectionItemTeaserHighlight({ teaser, sizes }: Props) {
	const imageComp = <ImageModule image={teaser.media} enableZoomEffect={true} sizes={sizes} />;

	return (
		<Tracktor
			trackingData={{
				data: {
					target: {
						title: teaser.title,
						url: teaser.link.href,
					},
					type: TrackEventDataType.BoardClick,
				},
			}}
		>
			{({ trackEvent }) => (
				<BoardSectionItemHighlight image={imageComp} onClick={() => trackEvent({})} path={teaser.link.href} title={teaser.title} />
			)}
		</Tracktor>
	);
}
